export const SAVE_CARD='SAVE_CARD'
export const SAVE_CARD_SUCCESS='SAVE_CARD_SUCCESS'
export const SAVE_CARD_ERROR='SAVE_CARD_ERROR'

export const SaveCard = (data) => ({
    type: SAVE_CARD,
    payload: data
})